import {
  Checkbox,
} from '@mui/material';
import { Box } from '@mui/system';
import { FlexRow } from 'common/FlexRow';
import { ImageUrlEditor } from 'components/editor/ImageUrlEditor';
import { SelectEditor } from 'components/editor/SelectEditor';
import { ValueEditor } from 'components/editor/ValueEditor';
import { Vec2Editor } from 'components/editor/Vec2Editor';
import { PublishSection } from 'components/PublishButton';
import { useRoot } from 'components/RootProvider';
import { useStructures } from 'components/useStructures';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { AssetType } from 'stores/RootStore';
import { StructureDO } from 'stores/Structure';
import { Structure } from '@sophya/eyekia';
import { ColorPresetPanel } from './ColorPresetPanel';
import { StructureImagePanel } from './StructureImagePanel';
import { FlexColumn } from '../../common/FlexColumn';

type StructurePanelProps = {
  id: string;
  structureDO: StructureDO;
};
export const StructurePanel = observer((props: StructurePanelProps) => {
  const floors = useStructures().floors;
  const root = useRoot();
  const { structureDO } = props;
  const history = useHistory();

  return (
    <>
      <FlexRow>
        <FlexColumn width='100%'>
          <img
            src={structureDO.previewUrl()}
            hidden={true}
            crossOrigin='anonymous'
            onLoad={ev => {
              structureDO.setBaseColor(ev.currentTarget);
            }}
          ></img>
          <ValueEditor value={structureDO.name} />
          <ValueEditor value={structureDO.description} />
          <ValueEditor value={structureDO.accessKey} />
          <ValueEditor value={structureDO.height} />
          <ValueEditor value={structureDO.pixelDensity} />
          {structureDO.isWall() && (
            <Box>
              is a Corner Piece?
              <Checkbox
                checked={structureDO.isCorner}
                onChange={() => structureDO.toggleCorner()}
              />
            </Box>
          )}
          <ColorPresetPanel 
            store={structureDO.colorPresets}
            onCalculateDefaultBaseColor={() => structureDO.calculateDefaultBaseColor()}
          ></ColorPresetPanel>
          <FlexRow>
            {structureDO.getOrientations().map((image) => {
              return (
                <StructureImagePanel key={image.orientation} image={image}/>
              );
            })}
          </FlexRow>
        </FlexColumn>
      </FlexRow>
      <PublishSection asset={structureDO} />
    </>
  );
});
